import merchantProvider from "src/providers/merchant-provider";
import type { Merchant } from "src/types";
import { create } from "zustand";
import { useShallow } from "zustand/shallow";

type MerchantsStore = {
	merchants: Merchant[] | undefined;
	setMerchants: (merchants: Merchant[] | undefined) => void;
	getMerchants: () => Promise<Merchant[]>;
};

const useMerchantsStore = create<MerchantsStore>((set) => ({
	merchants: undefined,
	setMerchants: (merchants) => set({ merchants }),
	getMerchants: async () => {
		const merchants = await merchantProvider.listMerchants();
		set({ merchants });
		return merchants;
	},
}));

export const useSharedMerchants = () =>
	useMerchantsStore(
		useShallow((s) => ({
			merchants: s.merchants,
			getMerchants: s.getMerchants,
		})),
	);

export default useSharedMerchants;
